import script from "./fault.vue?vue&type=script&lang=ts&setup=true"
export * from "./fault.vue?vue&type=script&lang=ts&setup=true"

import "./fault.vue?vue&type=style&index=0&id=53517934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53517934"]])

export default __exports__